/* DESIGN MADE – Guard v4
   A) Dedup: jede Theme-Asset-.js nur EINMAL laden (mehrfach eingebundene
      Komponenten aus Hauptprodukt + Quick-View + Flexible-Area entschaerfen)
   B) Persistentes Fehler-Protokoll in localStorage (Abruf via dmGuardShow())
   Laeuft frueh & synchron im <head>, vor den Body-Skripten. */
(function () {
  var T = "[DM-GUARD]";
  var LOGKEY = "dmGuardLog";

  // ---------- B) Persistentes Fehler-Protokoll ----------
  function logEvent(kind, detail) {
    try {
      var entry = {
        ts: new Date().toISOString(),
        page: location.pathname,
        kind: kind,
        detail: String(detail).slice(0, 300)
      };
      var arr = JSON.parse(localStorage.getItem(LOGKEY) || "[]");
      arr.push(entry);
      if (arr.length > 50) arr = arr.slice(-50);
      localStorage.setItem(LOGKEY, JSON.stringify(arr));
      console.warn(T, kind, detail);
    } catch (x) {}
  }
  window.dmGuardShow = function () {
    try { return JSON.parse(localStorage.getItem(LOGKEY) || "[]"); } catch (x) { return []; }
  };
  window.dmGuardClear = function () { try { localStorage.removeItem(LOGKEY); } catch (x) {} };

  window.addEventListener("error", function (e) {
    var src = (e && (e.filename || (e.target && (e.target.src || e.target.href)))) || "(inline)";
    logEvent("script-error", ((e && e.message) || (e && e.type) || "") + " @ " + src);
  }, true);
  window.addEventListener("unhandledrejection", function (e) {
    logEvent("promise-error", (e && e.reason) || "");
  });
  window.addEventListener("load", function () {
    setTimeout(function () {
      try {
        if (!window.Alpine) {
          logEvent("alpine-missing", "Alpine.js wurde NICHT geladen - evtl. blockiert ein Dritt-/App-Skript.");
        }
      } catch (x) {}
    }, 4000);
  });

  // ---------- A) Dedup gleicher Theme-Asset-.js ----------
  try {
    var seen = {};
    function assetName(url) {
      try {
        if (!url || url.indexOf("/cdn/shop/t/") === -1) return null;
        if (url.indexOf("/assets/") === -1) return null;
        return url.split("/assets/")[1].split("?")[0];
      } catch (x) { return null; }
    }
    function dedupeStatic() {
      try {
        var tags = document.querySelectorAll('script[src*="/cdn/shop/t/"][src*="/assets/"]');
        Array.prototype.forEach.call(tags, function (s) {
          var n = assetName(s.src);
          if (!n) return;
          if (seen[n]) { s.parentNode && s.parentNode.removeChild(s); }
          else { seen[n] = true; }
        });
      } catch (x) {}
    }
    dedupeStatic();
    document.addEventListener("DOMContentLoaded", dedupeStatic);

    var origCreate = document.createElement.bind(document);
    document.createElement = function (tag) {
      var el = origCreate(tag);
      if (String(tag).toLowerCase() === "script") {
        try {
          var nativeSet = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src");
          if (nativeSet && nativeSet.set) {
            Object.defineProperty(el, "src", {
              configurable: true,
              get: function () { return nativeSet.get.call(el); },
              set: function (v) {
                var n = assetName(v);
                if (n) {
                  if (seen[n]) { return; }
                  seen[n] = true;
                }
                nativeSet.set.call(el, v);
              }
            });
          }
        } catch (x) {}
      }
      return el;
    };
  } catch (x) {}
})();
